import React from 'react';
import ServiceOffered from '../../components/services/serviceOffered';

function service() {
  return (
    <>
      <ServiceOffered />
    </>
  )
}

export default service